import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import RootLoader from './RootLoader';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <RootLoader />
  </React.StrictMode>,
);
